var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrismaDark = function SvgPrismaDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 159 195"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prisma-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.397 123.367a9.63 9.63 0 0 0 .077 10.192l35.622 56.193a9.63 9.63 0 0 0 10.905 4.069l102.797-30.839c5.61-1.683 8.432-7.941 5.98-13.26L91.695 6.372c-3.222-6.99-12.938-7.564-16.961-1.001zM89.94 39.144c-1.404-3.25-6.16-2.75-6.857.722L57.64 166.544c-.537 2.671 1.964 4.952 4.575 4.173l71.025-21.202a3.61 3.61 0 0 0 2.282-4.894z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prisma-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h159v195H0z"
  })))));
};
export default SvgPrismaDark;